import { LangType } from '../../helpers/lang';
import { buildParams } from '../../helpers/path';
import { PaginationRequest, PaginationType } from '../../types/pagination';
import { SortRequest, WithArchiveRequest } from '../../types/props';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

const baseUrl = `${managerApiUrl}/lead`;

export type LeadContentType = 'full_name' | 'phone' | 'email' | 'sex' | 'age';

export type LeadType = {
  content: { type: LeadContentType; value?: string; is_required?: boolean }[];
  created_at: string;
  id: number;
  rating: {
    feedbacks: number;
    orders: number;
    requests: number;
  };
  source: LangType;
  title?: LangType;
  display_setting_type?: 'FULL_ON' | 'OFF' | 'RESTRICTED_ON';
  is_available?: boolean;
  is_deleted?: boolean;
};

export interface FetchLeadsRequest extends PaginationRequest, WithArchiveRequest, SortRequest {
  id?: string;
  name?: string;
  phone?: string;
  email?: string;
  sex?: string;
  age?: string;
  rating?: string;
  source?: string;
}

export const fetchLeads = async (
  params: FetchLeadsRequest,
): Promise<PaginationType & { leads: LeadType[] }> => {
  const response = await baseFetch(baseUrl + buildParams(params));
  return response;
};

export const deleteLead = async (id: string): Promise<void> => {
  const response = await baseFetch(baseUrl + `/${id}`, { method: 'DELETE' });
  return response;
};

export const restoreLead = async (id: string): Promise<void> => {
  const response = await baseFetch(baseUrl + `/${id}/restore`, { method: 'POST' });
  return response;
};

export const fetchLead = async (): Promise<LeadType> => {
  const response = await baseFetch(baseUrl + '-form');
  return response;
};

export const postLead = async (params: Partial<LeadType>): Promise<LeadType> => {
  const response = await baseFetch(baseUrl + '-form', {
    method: 'POST',
    body: JSON.stringify(params),
  });
  return response;
};
